import { Box, Skeleton } from '@mui/material';
import { colors } from '@src/styles';
import { skeletonSX } from '../scriptsStyles';

interface ActionsTableSkeletonProps {
  rowCount?: number;
}

const GRID_COLUMNS = '90px minmax(240px, 1fr) 110px 140px 140px 130px 80px 56px';

const URL_WIDTHS = ['64%', '78%', '56%', '70%', '60%', '74%', '52%', '68%', '58%', '72%'];

export const ActionsTableSkeleton = ({ rowCount = 10 }: ActionsTableSkeletonProps) => {
  return (
    <Box
      aria-busy="true"
      aria-label="Carregando actions"
      sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <Box sx={{ minWidth: 760 }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: GRID_COLUMNS,
              gap: 2,
              alignItems: 'center',
              paddingX: 2,
              paddingY: 1.5,
              borderBottom: `1px solid ${colors.brand.line}`,
            }}
          >
            {[50, 30, 46, 56, 70, 48, 40, 0].map((width, index) => (
              <Skeleton key={index} variant="text" width={width} height={14} sx={skeletonSX} />
            ))}
          </Box>
          {Array.from({ length: rowCount }, (_, index) => (
            <Box
              key={index}
              sx={{
                display: 'grid',
                gridTemplateColumns: GRID_COLUMNS,
                gap: 2,
                alignItems: 'center',
                minHeight: 50,
                paddingX: 2,
                borderBottom: index === rowCount - 1 ? 'none' : `1px solid ${colors.brand.line}`,
              }}
            >
              <Skeleton variant="rounded" width={44} height={20} sx={{ ...skeletonSX, borderRadius: '6px' }} />
              <Skeleton variant="text" width={URL_WIDTHS[index % URL_WIDTHS.length]} height={16} sx={skeletonSX} />
              <Skeleton variant="text" width={78} height={16} sx={skeletonSX} />
              <Skeleton variant="text" width={110} height={16} sx={skeletonSX} />
              <Skeleton variant="text" width={110} height={16} sx={skeletonSX} />
              <Skeleton variant="rounded" width={96} height={22} sx={{ ...skeletonSX, borderRadius: '999px' }} />
              <Skeleton variant="text" width={16} height={16} sx={{ ...skeletonSX, mx: 'auto' }} />
              <Skeleton
                variant="rounded"
                width={30}
                height={30}
                sx={{ ...skeletonSX, borderRadius: '8px', ml: 'auto' }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
